const MovingRoutes = {
  createVehicle: "/createVehicle",
  getVehicle: "/getVehicle",
  deleteVehicle: "/deleteVehicle",
  updateVehicle: "/updateVehicle",
};

export default MovingRoutes;
